import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function markThreadMessageAsOpenSuccess(draft: Draft<IInterventionData>) {
  draft.markThreadMessageAsOpen.config.isLoading = false;
}

export default markThreadMessageAsOpenSuccess;
